import { Entity } from './entity';

export abstract class BookFeature extends Entity {
    index: number;
    pageId: number;
}
